import { StringService } from '@lemon/core/service/string.service'
import { LASKUN_YKSIKKOLUETTELO, LaskunYksikko } from '../../model/laskun-yksikot'
import { YKSIKKOKOODIT_UN } from '../../model/yksikkokoodit-un'

export const KAPPALEEN_UN_KOODI = 'H87'

interface YksikonOsuma {
  yksikko: LaskunYksikko
  osuvuus: number
}

export class YksikkoService {
  constructor(private _stringService: StringService) {}

  annaUnKoodiLaskurivinYksikolle(yksikko: string | null | undefined): string | null {
    if (!yksikko) {
      return null
    }
    const laskunYksikko = LASKUN_YKSIKKOLUETTELO.find(luettelonYksikko => luettelonYksikko.tunnus === yksikko)
    if (laskunYksikko?.unKoodi) {
      return laskunYksikko.unKoodi
    }
    const annettuKoodi = yksikko.trim().toUpperCase()
    return this.onkoUnKoodi(annettuKoodi) ? annettuKoodi : null
  }

  onkoUnKoodi(koodi: string): boolean {
    return !!YKSIKKOKOODIT_UN[koodi]
  }

  annaUnKoodinNimi(koodi: string): string | null {
    return YKSIKKOKOODIT_UN[koodi] ?? null
  }

  haeYksikoita(hakusana: string, enintaan: number): LaskunYksikko[] {
    const haettava = this._normalisoi(hakusana)
    if (!haettava) {
      return LASKUN_YKSIKKOLUETTELO.filter(yksikko => yksikko.yleinen).slice(0, enintaan)
    }
    const osumat: YksikonOsuma[] = []
    for (const yksikko of LASKUN_YKSIKKOLUETTELO) {
      const osuvuus = this._annaOsuvuus(yksikko, haettava)
      if (osuvuus !== null) {
        osumat.push({ yksikko, osuvuus })
      }
    }
    osumat.sort((a, b) => a.osuvuus - b.osuvuus || Number(b.yksikko.yleinen) - Number(a.yksikko.yleinen))
    return osumat.slice(0, enintaan).map(osuma => osuma.yksikko)
  }

  annaYksikkoTunnuksellaTaiNimella(teksti: string): LaskunYksikko | null {
    const haettava = this._normalisoi(teksti)
    if (!haettava) {
      return null
    }
    return LASKUN_YKSIKKOLUETTELO.find(yksikko => this._normalisoi(yksikko.tunnus) === haettava || this._normalisoi(yksikko.nimi) === haettava) ?? null
  }

  private _annaOsuvuus(yksikko: LaskunYksikko, haettava: string): number | null {
    const tunnus = this._normalisoi(yksikko.tunnus)
    const nimi = this._normalisoi(yksikko.nimi)
    const koodi = this._normalisoi(yksikko.unKoodi)
    if (tunnus === haettava) {
      return 0
    }
    if (tunnus.startsWith(haettava)) {
      return 1
    }
    if (nimi.startsWith(haettava)) {
      return 2
    }
    const sisaltaaHaettavan = tunnus.includes(haettava) || nimi.includes(haettava) || koodi.includes(haettava)
    return sisaltaaHaettavan ? 3 : null
  }

  private _normalisoi(teksti: string | null | undefined): string {
    return this._stringService.removeAllWhiteSpaces((teksti ?? '').toLowerCase())
  }
}
